<template>
  <!-- 上方title -->
  <div>
    <div class="title">
      <p style="text-align: left">品名</p>
      <p>單價</p>
      <p>數量</p>
      <p>總價</p>
    </div>
  </div>
  <!-- 下方content -->
  <div class="wrap">
    <!-- 購物車 -->
    <div style="padding-bottom: 5px">
      <!-- 空 -->
      <div v-if="getCart?.length === 0" class="empty">
        <p>
          點選右方品項
          <br />
          加入清單
        </p>
      </div>
      <!-- 購物車內容 -->
      <div v-else class="cart-wrap" :style="`grid-template-rows: ${pageItem}fr 1fr`">
        <div :style="`display: grid; grid-template-rows: repeat(${pageItem}, ${100 / pageItem}%);`">
          <div
            v-for="(item, index) in renderList"
            :key="index"
            :class="[
              'cart-item',
              !item.can_delete && !item.can_show_detail && !item.can_duplicate ? 'cart-item-disabled' : '',
              item.item_type === 0 ? '' : 'discount-item',
              item.form_source_code ? 'meal-item' : '',
              selectItem?.item_id === item.item_id ? 'cart-item-selected' : '',
            ]"
            @click="handleClickItem(item)"
          >
            <p :class="['item-name', item.item.label.toString().length > 8 ? 'size-16' : '']">
              {{ item.item_index }}{{ item.item_type === 0 ? '.' : ' ' }}{{ item.item.label }}
            </p>
            <p>{{ item.show_price }}</p>
            <p>{{ item.quantity }}</p>
            <p :class="['item-price', item.subtotal.toString().length > 4 ? 'size-16' : '']">
              {{ item.subtotal }}
            </p>
            <p class="item-note">{{ item.description }}&emsp;{{ item.note ? `註：${item.note}` : '' }}</p>
          </div>
        </div>
        <div class="page">
          <cus-page :totalPage="totalPage" v-model:currentPage="currentPage" :handleClick="checkIsEdit"></cus-page>
        </div>
      </div>
    </div>
    <!-- 按鈕 -->
    <div class="d-flex">
      <cus-button
        v-if="selectItem && selectItem.replace_products"
        text="更換"
        color="yellow"
        :width="50"
        style="padding-left: 0"
        @click="replaceItem"
      ></cus-button>
      <cus-button
        v-else
        text="複製"
        color="yellow"
        :width="50"
        style="padding-left: 0"
        :disabled="getCart?.length === 0 || !selectItem || !selectItem.can_duplicate"
        @click="addCopyItem"
      ></cus-button>
      <cus-button
        text="刪除"
        color="red"
        :width="50"
        style="padding-right: 0"
        :disabled="getCart?.length === 0 || !selectItem || !selectItem.can_delete"
        @click="handleDeleteItem"
      ></cus-button>
    </div>
    <!-- 費用 -->
    <div class="cost-wrap">
      <div v-for="(item, index) in costTable" :key="index" class="cost-item">
        <span :class="item.label === '總計' ? 'total-label' : ''">{{ item.label }}</span>
        <span
          v-if="item.label === '總計'"
          class="total-number"
          :style="getTransaction[item.value].toString().length > 5 ? 'font-size:2.5rem' : 'font-size:3.6rem'"
        >
          {{ getTransaction[item.value] }}
        </span>
        <span v-else-if="item.label === '字軌'">{{ getInvoice[item.value] }}</span>
        <span v-else>{{ getTransaction[item.value] }}</span>
      </div>
    </div>
  </div>

  <!-- 彈窗 -->
  <component :is="dialogTemplate"></component>
</template>
<script>
import { ref, reactive, watch, computed, getCurrentInstance, defineAsyncComponent } from 'vue';
import { useGetters, useMutations, useActions } from '@/utils/mapStore';
import { useDialog } from '@/utils/dialog';
export default {
  name: 'cart',
  components: {
    MoreSelect: defineAsyncComponent(() => import('@/components/dialog/MoreSelect.vue')),
    Computer: defineAsyncComponent(() => import('@/components/dialog/Computer.vue')),
  },
  setup() {
    const { proxy } = getCurrentInstance();
    //取得購物車清單
    const getCart = useGetters('cart', ['getCart']);
    const copyAllCartList = computed(() => JSON.parse(JSON.stringify(getCart.value)));
    //取得交易資訊
    const { getTransaction, getInvoice } = useGetters('checkout', ['getTransaction', 'getInvoice']);
    const costTable = reactive([
      { label: '序號', value: 'serial_no' },
      { label: '字軌', value: 'invoice_no' },
      { label: '數量', value: 'quantity' },
      { label: '小計', value: 'sub_total' },
      { label: '總折扣', value: 'discount' },
      { label: '總計', value: 'total' },
    ]);
    //設定參數
    const selectItem = ref(null);
    const currentPage = ref(1);
    //處理分頁品項
    const pageItem = ref(8);
    const totalPage = computed(() => Math.ceil(copyAllCartList.value.length / pageItem.value));
    const renderList = computed(() =>
      copyAllCartList.value?.slice((currentPage.value - 1) * pageItem.value, currentPage.value * pageItem.value)
    );
    watch(copyAllCartList, (list, prevList) => {
      //新增品項時，頁碼=最後一頁
      if (list.length > prevList.length) currentPage.value = totalPage.value;
      //刪除品項時，縮減頁碼
      if (list.length < prevList.length && currentPage.value > totalPage.value) currentPage.value = totalPage.value;
    });

    //如取消detail頁面將selectIndex歸零
    const isMenuDetail = useGetters('menuItem', ['isMenuDetail']);
    watch(isMenuDetail, () => {
      if (!isMenuDetail.value && selectItem.value?.can_show_detail) selectItem.value = null;
      else if (isMenuDetail.value && !selectItem.value?.can_show_detail) selectItem.value = null;
    });
    //如果該頁只剩折扣品項，則取消selectItem
    const doCancelItem = useActions('menuItem', ['doCancelItem']);
    watch(renderList, () => {
      const onlyHasDiscount = renderList.value.every((e) => e.item_type === 1);
      if (onlyHasDiscount) {
        selectItem.value = null;
        doCancelItem();
      }
    });
    //新增同項時取消selectItem
    const getItemId = useGetters('menuItem', ['getItemId']);
    watch(getItemId, () => {
      if (!getItemId.value && isMenuDetail.value) selectItem.value = null;
    });

    //點擊品項
    const getIsEdit = useGetters('menuItem', ['getIsEdit']);
    const SET_IS_EDIT = useMutations('menuItem', ['SET_IS_EDIT']);
    const doSetItemDetail = useActions('menuItem', ['doSetItemDetail']);
    const { doHandleCartItem, doUpdateItemQuantity } = useActions('cart', ['doHandleCartItem', 'doUpdateItemQuantity']);
    const handleClickItem = (item) => {
      if (!item.can_delete && !item.can_duplicate && ( !item.can_show_detail && item.item_type != 2) ) return;
      else if ( item.item_type == 2) {
        //顯示數字鍵盤 讓他可以改數字
        selectItem.value = item;
        openDialog('quantity',  {
          init: item.quantity,
        }, {
          submitFunc: 'handleItemType2Quantity',
        });
      }
      else if (item.item_id === selectItem.value?.item_id) return;
      const doClickItem = () => {
        SET_IS_EDIT(false);
        selectItem.value = item;
        if (item.can_show_detail) {
          const copyOne = JSON.parse(JSON.stringify(item));
          doSetItemDetail(copyOne);
        } else {
          doCancelItem();
        }
      };
      if (getIsEdit.value) {
        proxy
          .$confirm({
            title: '錯誤提示',
            content: `尚未儲存「${selectItem.value?.item.label}」變更的內容`,
            cancelText: '繼續編輯',
            confirmText: '直接儲存',
          })
          .then(async () => {
            await doHandleCartItem('noCopy');
            doClickItem();
          })
          .catch((e) => e);
      } else {
        doClickItem();
      }
    };

    const handleItemType2Quantity = async (num) => {
      if (num === 0 || !selectItem.value) {
        closeDialog();
        return;
      }
      try {
        // 更新品項數量
        selectItem.value.quantity = num;
        await doUpdateItemQuantity({ item: selectItem.value});
        // await doHandleCartItem('noCopy');
        closeDialog();
        selectItem.value = null;
      } catch (error) {
        console.error('更新數量失敗:', error);
        closeDialog();
      }
    };
    //換頁
    const checkIsEdit = (val) => {
      const changePage = () => {
        currentPage.value = val;
        if (selectItem.value !== null) {
          selectItem.value = null;
          doCancelItem();
        }
      };
      if (getIsEdit.value) {
        proxy
          .$confirm({
            title: '錯誤提示',
            content: `尚未儲存「${selectItem.value?.item.label}」變更的內容`,
            cancelText: '繼續編輯',
            confirmText: '直接儲存',
          })
          .then(async () => {
            await doHandleCartItem('noCopy');
            changePage();
          })
          .catch((e) => e);
        return;
      } else {
        changePage();
      }
    };
    //換頁取消detail頁面
    watch(currentPage, () => {
      if (selectItem.value !== null) {
        selectItem.value = null;
        doCancelItem();
      }
    });

    //刪除品項
    const { doRemoveItem, doRemoveEvent } = useActions('cart', ['doRemoveItem', 'doRemoveEvent']);
    const handleDeleteItem = () => {
      proxy
        .$confirm({
          content: `是否確定要刪除「${selectItem.value?.item.label}」？`,
        })
        .then(async () => {
          if (selectItem.value?.item_type === 13) {
            await doRemoveEvent(selectItem.value?.form_source_code);
          } else {
            await doRemoveItem(selectItem.value?.item_id);
          }
          selectItem.value = null;
          doCancelItem();
        })
        .catch((e) => e);
    };

    //複製品項
    const addCopyItem = async () => {
      if (getIsEdit.value) {
        proxy.$message('錯誤提示', `尚未儲存「${selectItem.value?.item.label}」變更的內容`).catch((e) => e);
        return;
      }
      try {
        await doHandleCartItem('addCopyItem');
        selectItem.value = null;
        doCancelItem();
        // console.log(res);
        // const copyOne = JSON.parse(JSON.stringify(res));
        // doSetItemDetail(copyOne);
        // SET_IS_EDIT(false);
        // selectItem.value = res;
      } catch (e) {
        return false;
      }
    };

    //使用彈窗
    const { dialogTemplate, openDialog, closeDialog } = useDialog();
    //更換品項
    const getAllProducts = useGetters('list', ['getAllProducts']);
    const replaceItem = () => {
      const dialogList = [];
      selectItem.value.replace_products.forEach((e) => {
        if (getAllProducts.value[e]?.short_name)
          dialogList.push({ label: getAllProducts.value[e]?.short_name, value: e });
      });
      openDialog('selectReplaceItem', {}, { dialogList });
    };
    const doReplaceItem = useActions('cart', ['doReplaceItem']);
    const handleSelectReplaceItem = async (val) => {
      // console.log(val);
      await doReplaceItem(val);
      closeDialog();
      selectItem.value = null;
      doCancelItem();
    };

    return {
      getCart,
      getTransaction,
      getInvoice,
      costTable,
      pageItem,
      totalPage,
      renderList,
      selectItem,
      currentPage,
      handleClickItem,
      handleItemType2Quantity,
      checkIsEdit,
      handleDeleteItem,
      addCopyItem,
      dialogTemplate,
      replaceItem,
      handleSelectReplaceItem,
    };
  },
};
</script>
<style lang="scss" scoped>
$column_name: 51.5%; //品名
$column_detail: 13.5%; //單價、數量、折扣

.title {
  text-align: right;
  display: grid;
  grid-template-columns: $column_name repeat(2, $column_detail) 1fr;
  color: #fff;
  background-color: $color-darkBlue;
  width: 100%;
  border-radius: 4px;
  min-height: 5.2vh;
  padding: 0 9px;
  line-height: 5.2vh;
  font-size: 1.8rem;
}
.wrap {
  height: 100%;
  display: grid;
  grid-template-rows: $content-main $content-button * 0.46 auto;
}
.empty {
  width: 100%;
  height: 100%;
  text-align: center;
  color: #fff;
  background-color: $color-darkBlue;
  border-radius: 4px;
  @include flex-center-center;
}
.cost-wrap {
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(3, 1fr);
  grid-auto-flow: column;
  color: #fff;
  font-size: 1.8rem;
  align-items: center;
  // &::after {
  //   content: '';
  //   width: 45%;
  //   height: 10px;
  //   background-color: $color-yellow;
  //   position: absolute;
  //   bottom: -10px;
  //   right: 12px;
  //   border-radius: 7px 7px 0 0;
  // }
  .cost-item {
    display: flex;
    justify-content: space-between;
    padding: 0 12px 0 6px;
  }
  .total {
    &-label {
      color: $color-yellow;
    }
    &-number {
      color: $color-yellow;
      font-size: 3.6rem;
      line-height: 1.8rem;
    }
  }
}
.cart-wrap {
  @include white-bg;
  width: 100%;
  height: 100%;
  display: grid;
  padding-top: 5px;
  .cart-item {
    width: 100%;
    text-align: right;
    display: grid;
    grid-template-columns: minmax(0, $column_name) repeat(2, $column_detail) minmax(0, 1fr);
    grid-template-rows: 1fr 1fr;
    align-items: center;
    padding: 2px 9px 0;
    cursor: pointer;
    transition: 0.2s;
    .item-name {
      width: 100%;
      text-align: left;
      font-size: 2rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-weight: 500;
      color: $color-blue;
      transition: 0.2s;
    }
    .item-price {
      font-size: 2rem;
      font-weight: 500;
      color: $color-blue;
      transition: 0.2s;
    }
    .size-16 {
      font-size: 1.65rem;
    }
    .red {
      color: $color-red;
    }
    .item-note {
      width: 100%;
      grid-column: 1/6;
      align-self: flex-start;
      height: 100%;
      text-align: left;
      color: $color-gray-60;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      border-bottom: 1px solid $color-gray-10;
      transition: 0.2s;
    }
  }
  .discount-item {
    color: $color-red;
    .item-name {
      color: $color-red;
    }
    .item-price {
      color: $color-red;
    }
  }
  .cart-item-selected {
    color: #fff !important;
    background-color: $color-blue !important;
    .item-name,
    .item-price,
    .item-note {
      color: #fff !important;
      border-bottom: none !important;
    }
  }
  .cart-item-disabled {
    background-color: $color-gray-6;
  }
  .meal-item {
    background-color: rgba(242, 180, 0, 0.12);
  }
}
</style>
